import { VariableModel } from "../VariableModel";
import { getSettingBoolean } from "./settingUtilities";

export const getDefaultChoices = (variable: VariableModel) => {
    return variable.choiceList.filter((c) => getSettingBoolean(c, "Default"));
};

export const getChoice = (variable: VariableModel, choiceCode: string) => {
    return variable.choiceList.find(
        (c) => (c.value || "").toLowerCase() === (choiceCode || "").toLowerCase(),
    );
};
